import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { InspectionHttpDeleteRequestModel } from '../httpQueue/inspection/types';

export interface DeleteInspectionParams {
  inspectionId: string;
  projectId: string;
  uniqueId: string;
}

export class InspectionDeleter {
  constructor(
    private addRequest: (
      request: InspectionHttpDeleteRequestModel
    ) => Promise<unknown>
  ) {}

  async execute({
    inspectionId,
    projectId,
    uniqueId,
  }: DeleteInspectionParams): Promise<void> {
    debugLog('DeleteInspectionUseCase', inspectionId);
    await this.addRequest({
      createdAt: Date.now(),
      method: 'DELETE',
      data: {
        inspectionId,
        projectId,
        uniqueId,
      },
      url: `/project/${projectId}/inspection/${inspectionId}`,
      entityType: HttpRequestModelType.inspection,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionDeleter = new InspectionDeleter(addRequest);
